module.exports = __webpack_public_path__ + "img/pick_up.7a73b909.svg";